var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyNotAndAlerts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 86,
    viewBox: "0 0 88 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42403 70.288C8.8281 69.8984 8.29091 69.4815 7.81388 69.0446C7.23228 68.5103 6.3255 68.549 5.78974 69.132C5.25541 69.7136 5.29409 70.6204 5.87712 71.1547C6.46302 71.6933 7.12341 72.2062 7.85686 72.6861C8.51868 73.1187 9.40684 72.9325 9.83946 72.2706C10.2721 71.6088 10.0859 70.7207 9.42403 70.288Z",
    fill: "url(#paint0_linear_17671_2193)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95987 65.8879C4.53441 65.3106 4.17485 64.7305 3.87976 64.1503C3.52163 63.4455 2.65782 63.1647 1.95302 63.5228C1.24822 63.881 0.967452 64.7448 1.32558 65.4496C1.68944 66.163 2.13065 66.8778 2.65352 67.5869C3.12196 68.2229 4.01871 68.359 4.65618 67.8906C5.29221 67.4207 5.4283 66.524 4.95987 65.8879Z",
    fill: "url(#paint1_linear_17671_2193)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86544 60.0414C2.87976 59.4641 2.96428 58.904 3.11899 58.3668C3.33673 57.6076 2.89695 56.8125 2.13629 56.5948C1.37705 56.377 0.582009 56.8168 0.364267 57.5775C0.145092 58.3453 0.0218936 59.1461 0.000405849 59.9698C-0.0182169 60.7605 0.60636 61.4181 1.39711 61.4367C2.18786 61.4567 2.84538 60.8322 2.86544 60.0414Z",
    fill: "url(#paint2_linear_17671_2193)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06861 55.2572C5.43677 54.9163 5.84933 54.6011 6.30057 54.316C6.96956 53.8934 7.17011 53.0081 6.74895 52.3406C6.32636 51.6716 5.44107 51.4711 4.77208 51.8922C4.16613 52.2747 3.61604 52.6973 3.12182 53.1557C2.54165 53.6929 2.50727 54.5997 3.04447 55.1798C3.58166 55.76 4.48844 55.7944 5.06861 55.2572Z",
    fill: "url(#paint3_linear_17671_2193)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3973 52.785C11.1179 52.6517 11.8814 52.5658 12.6865 52.5328C13.4772 52.4985 14.0903 51.8295 14.0574 51.0402C14.0244 50.2508 13.3555 49.6363 12.5647 49.6692C11.6192 49.7093 10.7225 49.8111 9.87587 49.9672C9.09945 50.1119 8.58374 50.8597 8.72843 51.6361C8.87168 52.4139 9.61945 52.9282 10.3973 52.785Z",
    fill: "url(#paint4_linear_17671_2193)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8637 52.7037C19.0856 52.718 20.223 52.6751 21.2788 52.582C22.0667 52.5118 22.6497 51.8156 22.5795 51.0277C22.5093 50.2412 21.8131 49.6582 21.0253 49.7284C20.0583 49.8129 19.0169 49.853 17.8966 49.8387C17.1059 49.8301 16.457 50.4647 16.4484 51.254C16.4383 52.0448 17.0729 52.6951 17.8637 52.7037Z",
    fill: "url(#paint5_linear_17671_2193)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9858 51.702C27.404 51.268 28.6016 50.7122 29.6043 50.0747C30.2704 49.6492 30.4681 48.7639 30.0427 48.0964C29.6186 47.4303 28.7319 47.2326 28.0644 47.658C27.2578 48.1709 26.2909 48.6121 25.1478 48.9616C24.3928 49.1937 23.9659 49.9945 24.198 50.7508C24.4286 51.5072 25.2308 51.9327 25.9858 51.702Z",
    fill: "url(#paint6_linear_17671_2193)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2105 0.558594C55.806 0.558594 56.9406 5.20138 56.9406 9.15369C56.9406 13.1074 54.3735 14.8837 51.2105 14.8837C48.0475 14.8837 45.4805 13.1074 45.4805 9.15369C45.4805 5.20138 46.615 0.558594 51.2105 0.558594Z",
    fill: "url(#paint7_linear_17671_2193)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2114 0.558594C55.8069 0.558594 56.9415 5.20138 56.9415 9.15369C56.9415 13.1074 54.3744 14.8837 51.2114 14.8837C50.9249 14.8837 50.6427 14.8694 50.3662 14.8393C53.1295 14.5442 55.2525 12.7479 55.2525 9.15369C55.2525 5.2157 55.8026 0.594407 51.2644 0.558594H51.2114Z",
    fill: "#A4BBDB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2123 60.6406C68.2106 60.6406 80.5789 64.1703 82.0114 68.5195C83.3723 72.6494 68.2106 76.3983 51.2123 76.3983C34.2141 76.3983 19.0524 72.6494 20.4132 68.5195C21.8458 64.1703 34.2141 60.6406 51.2123 60.6406Z",
    fill: "url(#paint8_linear_17671_2193)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9524 64.9062C80.1728 65.9878 81.5824 67.2169 82.0107 68.5191C83.3716 72.649 68.2098 76.3979 51.2116 76.3979C41.6467 76.3979 32.6634 75.2103 26.8789 73.4369C31.5718 73.9712 36.7489 74.2749 42.0808 74.2749C61.9899 74.2749 79.7488 70.0418 78.1544 65.379C78.0999 65.22 78.0326 65.0624 77.9524 64.9062Z",
    fill: "#B8CAE3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2143 72.8017C55.1701 72.8017 58.3769 69.5949 58.3769 65.6391C58.3769 61.6834 55.1701 58.4766 51.2143 58.4766C47.2586 58.4766 44.0518 61.6834 44.0518 65.6391C44.0518 69.5949 47.2586 72.8017 51.2143 72.8017Z",
    fill: "url(#paint9_linear_17671_2193)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1578 66.8754C44.0876 66.4743 44.0518 66.0617 44.0518 65.6391C44.0518 61.6868 47.2606 58.4766 51.2143 58.4766C54.1123 58.4766 56.6106 60.2013 57.738 62.6796C56.433 62.1495 55.0076 61.8573 53.515 61.8573C49.6113 61.8573 46.1719 63.8514 44.1578 66.8754Z",
    fill: "#526B8F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.415 68.521C20.415 68.521 23.7943 59.5922 26.4803 52.4926C28.6262 46.8213 29.7264 40.809 29.7264 34.7466C29.7264 32.9259 29.7264 30.949 29.7264 28.9263C29.7264 23.6074 31.8393 18.5062 35.6011 14.7444C39.3615 10.9841 44.4627 8.87109 49.7816 8.87109H52.6466C57.9656 8.87109 63.0668 10.9841 66.8271 14.7444C70.5889 18.5062 72.7019 23.6074 72.7019 28.9263V34.8813C72.7019 40.991 73.8192 47.0505 75.9981 52.7591L82.0132 68.521C80.5807 64.1719 68.2124 60.6422 51.2141 60.6422C35.2774 60.6422 23.4119 63.745 20.8104 67.716L20.415 68.521Z",
    fill: "url(#paint10_linear_17671_2193)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4449 8.87109C31.1374 17.1396 36.2744 33.1637 33.1157 47.7782C32.219 51.9268 30.6532 57.7829 27.6707 63.6319C24.2012 64.7779 21.8146 66.1817 20.8104 67.716L20.415 68.521C20.415 68.521 23.7943 59.5922 26.4803 52.4926C28.6262 46.8213 29.7264 40.809 29.7264 34.7466C29.7264 32.9259 29.7264 30.949 29.7264 28.9263C29.7264 23.6074 31.8393 18.5062 35.6011 14.7444C39.3615 10.9841 44.4627 8.87109 49.7816 8.87109H50.4449Z",
    fill: "#F2F8FD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6658 77.6631L14.2544 83.0744H19.5512V85.0334H11.8765V82.6841L17.1857 77.3712H11.8174V75.4141H19.6658V77.6631Z",
    fill: "url(#paint11_linear_17671_2193)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7546 84.9598V83.2873L24.6303 80.4097H21.7188V78.8555H26.7719V80.4688L23.8353 83.4055H26.7039V84.9598H21.7546Z",
    fill: "url(#paint12_linear_17671_2193)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0409 84.9598V83.2873L31.9166 80.4097H29.0068V78.8555H34.0582V80.4688L31.1216 83.4055H33.9902V84.9598H29.0409Z",
    fill: "url(#paint13_linear_17671_2193)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1808 84.9573C37.6674 84.9573 38.0618 84.5629 38.0618 84.0763C38.0618 83.5897 37.6674 83.1953 37.1808 83.1953C36.6942 83.1953 36.2998 83.5897 36.2998 84.0763C36.2998 84.5629 36.6942 84.9573 37.1808 84.9573Z",
    fill: "url(#paint14_linear_17671_2193)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9884 84.9573C41.475 84.9573 41.8694 84.5629 41.8694 84.0763C41.8694 83.5897 41.475 83.1953 40.9884 83.1953C40.5019 83.1953 40.1074 83.5897 40.1074 84.0763C40.1074 84.5629 40.5019 84.9573 40.9884 84.9573Z",
    fill: "url(#paint15_linear_17671_2193)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6007 36.2229C82.4472 36.2229 87.9974 30.6728 87.9974 23.8263C87.9974 16.9798 82.4472 11.4297 75.6007 11.4297C68.7543 11.4297 63.2041 16.9798 63.2041 23.8263C63.2041 30.6728 68.7543 36.2229 75.6007 36.2229Z",
    fill: "url(#paint16_linear_17671_2193)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6006 30.2559C76.3315 30.2559 76.9239 29.6635 76.9239 28.9327C76.9239 28.2018 76.3315 27.6094 75.6006 27.6094C74.8698 27.6094 74.2773 28.2018 74.2773 28.9327C74.2773 29.6635 74.8698 30.2559 75.6006 30.2559Z",
    fill: "url(#paint17_linear_17671_2193)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9893 21.4667L68.1621 20.1523C69.5946 21.4327 71.2868 21.4595 72.7533 20.1523L73.9262 21.4667C71.8115 23.3469 69.1165 23.3576 66.9893 21.4667Z",
    fill: "url(#paint18_linear_17671_2193)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9463 21.4667L78.1192 20.1523C79.5517 21.4327 81.2456 21.4595 82.7104 20.1523L83.8832 21.4667C81.7685 23.3469 79.0736 23.3576 76.9463 21.4667Z",
    fill: "url(#paint19_linear_17671_2193)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17671_2193",
    x1: 17.4114,
    y1: 76.0242,
    x2: 17.4114,
    y2: 66.3199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17671_2193",
    x1: 11.6461,
    y1: 71.6761,
    x2: 11.6461,
    y2: 60.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17671_2193",
    x1: 8.17455,
    y1: 65.0141,
    x2: 8.17455,
    y2: 53.8339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17671_2193",
    x1: 13.7511,
    y1: 58.5354,
    x2: 13.7511,
    y2: 49.4811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17671_2193",
    x1: 22.4915,
    y1: 55.1027,
    x2: 22.4915,
    y2: 47.9332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17671_2193",
    x1: 32.2504,
    y1: 54.8854,
    x2: 32.2504,
    y2: 48.0747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17671_2193",
    x1: 39.9249,
    y1: 54.9277,
    x2: 39.9249,
    y2: 45.0415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17671_2193",
    x1: 47.2468,
    y1: 1.45965,
    x2: 56.0925,
    y2: 11.3168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_17671_2193",
    x1: 79.8082,
    y1: 75.0216,
    x2: 25.152,
    y2: 61.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_17671_2193",
    x1: 57.9672,
    y1: 73.3604,
    x2: 42.529,
    y2: 58.4379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#526B8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_17671_2193",
    x1: 40.4387,
    y1: 11.1803,
    x2: 74.4166,
    y2: 62.0633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_17671_2193",
    x1: 9.24883,
    y1: 74.2662,
    x2: 20.8211,
    y2: 78.0999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_17671_2193",
    x1: 20.065,
    y1: 78.1271,
    x2: 27.4942,
    y2: 80.6242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_17671_2193",
    x1: 27.3537,
    y1: 78.1271,
    x2: 34.7808,
    y2: 80.6226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_17671_2193",
    x1: 35.7232,
    y1: 82.9851,
    x2: 38.1983,
    y2: 83.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_17671_2193",
    x1: 39.5308,
    y1: 82.9851,
    x2: 42.0059,
    y2: 83.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_17671_2193",
    x1: 66.159,
    y1: 17.8872,
    x2: 88.0061,
    y2: 20.3305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_17671_2193",
    x1: 72.7774,
    y1: 25.7687,
    x2: 76.2898,
    y2: 31.7441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#526B8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_17671_2193",
    x1: 63.0577,
    y1: 18.2547,
    x2: 64.8769,
    y2: 26.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#526B8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_17671_2193",
    x1: 73.0148,
    y1: 18.2547,
    x2: 74.8339,
    y2: 26.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#738BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#526B8F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotAndAlerts);
export default __webpack_public_path__ + "static/media/EmptyNotAndAlerts.be3ea5b2d3c3a08e87e91de2aa2adbcf.svg";
export { ForwardRef as ReactComponent };